import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/ui/layout.js";
import Doc from 'unified-doc';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h3 {...{
      "id": "overview"
    }}>{`Overview`}</h3>
    <p>{`Bare concepts to get started with understanding how to initialize a `}<inlineCode parentName="p">{`doc`}</inlineCode>{` instance using `}<inlineCode parentName="p">{`unified-doc`}</inlineCode>{`.  More details and recipes are covered in further sections.`}</p>
    <h3 {...{
      "id": "render-to-html-string"
    }}>{`Render to HTML string`}</h3>
    <p>{`Simplest example of rendering any content into stringified HTML.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js",
        "metastring": "live=true",
        "live": "true"
      }}>{`// import Doc from 'unified-doc';

function () {
  const doc = Doc({
    content: '> **some** markdown content',
    filename: 'doc.md',
  });
  return <pre>{doc.compile().contents}</pre>
}
`}</code></pre>
    <h3 {...{
      "id": "render-to-code-block"
    }}>{`Render to code block`}</h3>
    <p>{`For any content other than `}<inlineCode parentName="p">{`.html`}</inlineCode>{` and `}<inlineCode parentName="p">{`.md`}</inlineCode>{`, we will conveniently render to a code block useful for displaying source code with relevant syntax highlighting.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js",
        "metastring": "live=true",
        "live": "true"
      }}>{`// import Doc from 'unified-doc';

function () {
  const doc = Doc({
    content: \`
      function greet() {
        return "hello world";
      }\`,
    filename: 'doc.js',
  });
  return <pre>{doc.compile().contents}</pre>
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      